import {
  Box,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Grid,
  TextField,
  Typography,
  Collapse,
  Paper,
} from '@mui/material';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import React from 'react';
import ButtonForm from 'components/buttons/button-form';
import { useStep5 } from './useStep5';

const Step5: React.FC = () => {
  const {
    formulario,
    grupos,
    isValid,
    handleEstrutura,
    handleQuantidade,
    handleQuantidadeBlur,
    errosQuantidade,
    toggleGrupo,
    handleAvancar,
    handleVoltar,
    stepAtual,
    totalSteps,
  } = useStep5();

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mt: 4,
          mb: 4,
          fontSize: '24px',
          fontWeight: 400,
          textAlign: 'center'
        }}
      >
        Estrutura
      </Typography>
      <ContainerFormFormik title='Informações sobre a Estrutura'>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormLabel
            sx={{
              color: '#333',
              marginBottom: 1,
              fontWeight: 'bold',
              fontSize: '16px',
            }}
          >
            De qual estrutura a Secretaria/Pasta de agricultura dispõe?
          </FormLabel>

          {/* Render Grouped Sections */}
          {grupos.map((grupo) => (
            <Paper key={grupo.id} variant="outlined" sx={{ mb: 2 }}>
              {/* Group Header - Collapsible */}
              <Box
                onClick={() => toggleGrupo(grupo.id)}
                sx={{
                  p: 2,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: '#f5f5f5',
                  '&:hover': {
                    backgroundColor: '#e8e8e8',
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: '#333',
                    flex: 1,
                  }}
                >
                  {grupo.titulo}
                </Typography>
                {grupo.isOpen ? (
                  <KeyboardArrowUpOutlined sx={{ color: '#666' }} />
                ) : (
                  <KeyboardArrowDownOutlined sx={{ color: '#666' }} />
                )}
              </Box>

              {/* Group Content - Collapsible */}
              <Collapse in={grupo.isOpen} timeout="auto" unmountOnExit>
                <Box sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    {grupo.items.map((item) => (
                      <Grid item xs={12} sm={6} key={item.key}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 2,
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  (formulario as any)?.[item.key] === true
                                }
                                onChange={(e) =>
                                  handleEstrutura(item.key, e.target.checked)
                                }
                              />
                            }
                            label={
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 500,
                                }}
                              >
                                {item.label}
                              </Typography>
                            }
                            sx={{
                              flex: 1,
                              m: 0,
                            }}
                          />
                          <TextField
                            size='small'
                            placeholder='Qtd'
                            value={
                              (formulario as any)?.[item.qtdKey]?.toString() ||
                              ''
                            }
                            onChange={(e) =>
                              handleQuantidade(item.qtdKey, e.target.value)
                            }
                            onBlur={() =>
                              handleQuantidadeBlur(item.qtdKey, item.key)
                            }
                            disabled={!(formulario as any)?.[item.key]}
                            error={errosQuantidade.has(item.qtdKey)}
                            helperText={
                              errosQuantidade.has(item.qtdKey)
                                ? 'Obrigatório'
                                : ''
                            }
                            sx={{
                              width: '100px',
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: errosQuantidade.has(item.qtdKey)
                                    ? '#d32f2f'
                                    : '#e0e0e0',
                                },
                                '&:hover fieldset': {
                                  borderColor: errosQuantidade.has(item.qtdKey)
                                    ? '#d32f2f'
                                    : '#1976d2',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: errosQuantidade.has(item.qtdKey)
                                    ? '#d32f2f'
                                    : '#1976d2',
                                },
                              },
                            }}
                            type='text'
                            inputProps={{
                              inputMode: 'numeric',
                              pattern: '[0-9]*',
                            }}
                          />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Collapse>
            </Paper>
          ))}
        </Box>
      </ContainerFormFormik>
      <ButtonForm
        disabled={!isValid}
        onBack={handleVoltar}
        onAdvanced={handleAvancar}
        stepAtual={stepAtual}
        totalSteps={totalSteps}
      />
    </>
  );
};

export default Step5;
